var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.771 75.7917H98.0833V26.75C98.0833 21.8323 94.0843 17.8332 89.1665 17.8332H17.8333C12.9157 17.8332 8.91653 21.8321 8.91653 26.75V75.7917H2.22903C0.997065 75.7917 0 76.7885 0 78.0207V80.25C0 85.1676 3.99892 89.1667 8.91674 89.1667H98.0835C103.001 89.1667 107 85.1676 107 80.25V78.0207C107 76.7885 106.003 75.7917 104.771 75.7917ZM13.375 26.75C13.375 24.2923 15.3756 22.2917 17.8333 22.2917H89.1665C91.6242 22.2917 93.6248 24.2923 93.6248 26.75V75.7917H64.6458H42.3542H13.375V26.75ZM98.0833 84.7082H8.91674C6.45908 84.7082 4.45847 82.7076 4.45847 80.25H11.146H41.4312L43.0073 81.8261C43.4253 82.2441 43.9912 82.4792 44.5835 82.4792H62.4167C63.0088 82.4792 63.5749 82.2441 63.9929 81.8261L65.5688 80.25H95.8542H102.542C102.542 82.7076 100.541 84.7082 98.0833 84.7082Z",
    fill: "#00A094"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9889 51.9574L55.128 47.5617V38.6076C55.128 37.7073 54.4003 36.9796 53.4999 36.9796C52.5996 36.9796 51.8719 37.7073 51.8719 38.6076V48.3759C51.8719 48.8887 52.1128 49.3722 52.5231 49.6783L59.0352 54.5624C59.3282 54.7822 59.6702 54.888 60.0104 54.888C60.5069 54.888 60.9953 54.665 61.3145 54.2352C61.8551 53.5171 61.7086 52.4963 60.9889 51.9574Z",
    fill: "#00A094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 27.2277C41.9101 27.2277 32.4822 36.6556 32.4822 48.2455C32.4822 59.8355 41.9101 69.2634 53.5 69.2634C65.09 69.2634 74.5179 59.8355 74.5179 48.2455C74.5179 36.6556 65.09 27.2277 53.5 27.2277ZM53.5 66.0073C43.7074 66.0073 35.7382 58.0381 35.7382 48.2455C35.7382 38.4529 43.7074 30.4837 53.5 30.4837C63.2943 30.4837 71.2619 38.4529 71.2619 48.2455C71.2619 58.0381 63.2926 66.0073 53.5 66.0073Z",
    fill: "#00A094"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.0357,
    height: 42.0357,
    fill: "white",
    transform: "translate(32.4822 27.2277)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.69529f3e72f229337b9aee9d68785d06.svg";
export { ForwardRef as ReactComponent };